import React, { useState, useEffect } from "react";
import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import * as API from "src/api/product";
import * as REQ from "src/api/request";
import { DatePicker, InputNumber, TreeSelect } from "antd";
import _ from "lodash";
import moment from "moment";
import DepartmentTree from "src/components/departmentTree";
import DepartmentTreeCode from "src/components/departmentTreeCode";
import PageHelp from "src/components/help/PageHelp";
const Header = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (state?.list_department?.length > 0 && state?.department === null) {
      var department = _.find(state?.list_department, {
        departmentcode: user?.info?.tseh_code,
      });

      dispatch({
        type: "STATE",
        data: { department: department?.id },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.list_department]);

  return (
    <div className="mb-2 pb-2 flex flex-col md:flex-row gap-3">
      <div className="flex items-center justify-between text-xs">
        <span className="md:w-[70px] font-semibold pr-1">Жил:</span>
        <div className="w-full md:min-w-[150px] ">
          <DatePicker
            allowClear={false}
            className="w-full md:w-[150px] text-xs"
            picker="year"
            value={moment(state.end_date)}
            onChange={(date) => {
              dispatch({
                type: "STATE",
                data: { end_date: date },
              });
            }}
          />
        </div>
      </div>

      <div className="flex items-center w-full  md:min-w-[200px] text-xs gap-2">
        <span className="font-semibold whitespace-nowrap ">Бүтцийн нэгж:</span>

        <DepartmentTreeCode
          value={state.department}
          onChange={(value) => {
            REQ.getUserDepartment().then((res) => {
              var result = _.filter(res, (a) => a.departmentcode === value);
              dispatch({ type: "STATE", data: { department: value } });

              dispatch({
                type: "STATE",
                data: {
                  register: {
                    ...state.register,
                    department: value,
                    negj_code: result[0].departmentcode,
                    negj_name: result[0].departmentname,
                  },
                },
              });
            });
          }}
        />
        {/* <TreeSelect
          showSearch
          allowClear={true}
          placeholder="Сонгоно уу"
          treeDataSimpleMode={true}
          className="w-full md:max-w-[500px]"
          treeData={state?.list_department}
          treeLine={(true, { showLeafIcon: false })}
          value={state.department}
          onChange={(value) => {
            dispatch({
              type: "STATE",
              data: { department: value },
            });
          }}
          filterTreeNode={(search, item) =>
            item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
          }
          open={open}
          onDropdownVisibleChange={(open) => setOpen(open)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              console.log(e.target.value);
              var reportdepartment = _.find(state?.list_department, {
                departmentcode: e.target.value,
              });
              console.log(reportdepartment);
              if (reportdepartment) {
                dispatch({
                  type: "STATE",
                  data: { department: reportdepartment.id },
                });
                setOpen(false);
              }
            }
          }}
        /> */}
        {/* <div className="flex items-center w-full text-xs">
        <span className="font-semibold whitespace-nowrap pr-5">Төрөл:</span>
        <Select
          value={state.datetype1}
          onChange={(value) => {
            dispatch({ type: "STATE", data: { datetype1: value } });
          }}
          className="w-full md:max-w-[400px] read-only: true"
        >
          <Option key="1" value="date_norm">
            Үндсэн нормын хугацаагаар
          </Option>
          <Option key="2" value="date_applied">
            Олгосон огноогоор
          </Option>
        </Select>
      </div> */}
      </div>

      {/* Тусламж — шүүлтийн мөрийн ТӨГСГӨЛД. Эдгээр хуудсанд гарчиг
          байхгүй тул толгойн баруун тал нь цорын ганц тогтвортой байр.
          Түлхүүр өгөөгүй нь САНААТАЙ — энэ толгойг хэд хэдэн зам
          хуваан ашигладаг тул PageHelp замаасаа өөрөө уншина. */}
      <div className="flex items-center">
        <PageHelp />
      </div>
    </div>
  );
};
export default Header;
